export const FREEDOM_DATE_FORMAT = "MMM DD, YYYY";
